var map = {
	"./arrow-down.svg": "mE25",
	"./location.svg": "mi/v",
	"./logo-mini.svg": "xhAB",
	"./phone.svg": "FRIT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YhPC";


//////////////////
// WEBPACK FOOTER
// ./static/images/sprite-icons ^\.\/.*\.svg$
// module id = YhPC
// module chunks = 1